import React, { Component } from "react";
import { connect } from "react-redux";
import { withFirebase } from "../Firebase";
import { schoolSelectors } from "../../store/school";
import PropTypes from "prop-types";
import { Table } from "reakit";
import styled from "styled-components";
import InfiniteScroll from "react-infinite-scroller";
import { Circle } from "styled-spinkit";

import { fontSize, fontWeight } from "styled-system";
import { Box, Flex, Text } from "rebass";
import { LeavesBar } from "../Cards";
import { Column, TableHeader, Title } from "./styles";
import TableHeaderDropdown from "./TableHeaderDropdown";
import DatepickerDropdown from "./DatepickerDropdown";
import BasicSearch from "../Forms/BasicSearch";
import { leaveUtils, returnFilterString } from "../../utils";
import { StudentFilterDropdown } from "../Search";
import { ACTOR_OPTIONS, STUDENT_OPTIONS } from "./constants";

const Head = styled.thead`
  ${fontSize}
  ${fontWeight}
`;

let timeout = null;

class LeavesTable extends Component {
  state = {
    searchTerm: "",
    isSearchTermChanged: false,
    studentFilters: {
      grade: [],
      location: [],
      dorm: [],
      gender: [],
      type: []
    },
    pageStart: 0,
    itemsPerPage: 10
  };

  handleSearchInput = e => {
    this.setState({
      searchTerm: e.target.value,
      isSearchTermChanged: false
    });
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      clearTimeout(timeout);
      timeout = null;
      this.setState({ isSearchTermChanged: true });
    }, 300);
  };

  handleSelectFilter = (name, index) => {
    const { filters } = this.props;
    let newFilters = filters;
    let filter = filters[index];
    let contains = false;
    for (var i = filter.length - 1; i >= 0; i--) {
      if (filter[i] === name) {
        filter.splice(i, 1);
        contains = true;

        newFilters[index] = filter;
      }
    }

    if (!contains) {
      filter.push(name);
      newFilters[index] = filter;
    }
    this.setState({ filters: newFilters });
    this.handleUpdateFilter(newFilters);
  };

  handleSelectDateFilter = (name, index) => {
    const { filters } = this.props;

    let newFilters = filters;

    newFilters[index] = name;

    this.setState({ filters: newFilters });

    this.handleUpdateFilter(newFilters);
  };

  handleUpdateFilter = filters => {
    const { handleUpdateFilter } = this.props;
    handleUpdateFilter(filters);
  };

  handleClearStudentFilter = () => {
    this.setState({
      studentFilters: {
        grade: [],
        location: [],
        dorm: [],
        gender: [],
        type: []
      }
    });
  };

  handleUpdateStudentFilters = filters => {
    this.setState({ studentFilters: filters });
  };

  handleFilterLeaves = () => {
    const { searchTerm, studentFilters, isSearchTermChanged } = this.state;
    const { leaves, filters } = this.props;
    let result = leaveUtils.filterLeaveResults(leaves, filters);
    if (isSearchTermChanged) {
      result = leaveUtils.filterLeavesByStudentName(result, searchTerm);
    }
    result = leaveUtils.filterLeavesByStudent(studentFilters, result);
    return result;
  };

  _getHeaderBackColor = () => {
    const { type, title } = this.props;
    const missed = title === "Missed";
    let col = "";
    if (missed) {
      col = "#f95050";
    } else {
      if (type === "Pending") {
        col = "yellow";
      } else {
        col = "#2BB99E";
      }
    }
    return col;
  };

  _getFilterColor = () => {
    const { type, title } = this.props;
    const missed = title === "Missed";
    let col = "";
    if (missed) {
      col = "opaqueMeta";
    } else {
      if (type === "Pending") {
        col = "opaqueMeta";
      } else {
        col = "#C5F0E8";
      }
    }
    return col;
  };

  loadMore = page => {
    this.setState({ pageStart: page });
  };

  returnLeaveList = items => {
    const { isAdmin, types, profile, type } = this.props;
    return (
      <tbody>
        {items.map(item => (
          <LeavesBar
            profile={profile}
            key={item.id}
            details={item}
            variant="leaves"
            types={types}
            isAdmin={isAdmin}
            leave_type={type}
          />
        ))}
      </tbody>
    );
  };

  compareTypes = (a, b) => {
    if (a.label > b.label) return 1;
    if (b.label > a.label) return -1;
    return 0;
  };

  render() {
    const { searchTerm, studentFilters } = this.state;
    const { title, schoolInfo, loadingSchool, filters, type } = this.props;
    let options = {
      leaveTypes: [],
      transportTypes: []
    };

    if (!loadingSchool) {
      options = leaveUtils.reduceSchoolToLeaveOptions(schoolInfo, true);
    }

    const filterTitle = loadingSchool
      ? "All Students"
      : returnFilterString(studentFilters, schoolInfo);

    const leavesResult = this.handleFilterLeaves();

    const { pageStart, itemsPerPage } = this.state;

    const items = leavesResult.slice(
      0,
      itemsPerPage + pageStart * itemsPerPage
    );

    const hasMore = items.length < leavesResult.length;
  

    return (
      <InfiniteScroll
        pageStart={pageStart}
        loadMore={this.loadMore}
        hasMore={hasMore}
        loader={
          <Flex justifyContent={"center"} flexWrap={"wrap"} width={1} key={0}>
            <Circle />
          </Flex>
        }
      >
        <Column>
          <TableHeader
            flexDirection={"row"}
            flexWrap={"wrap"}
            bg={this._getHeaderBackColor()}
            color={"white"}
          >
            <Flex width={1} flexDirection={"row"} p={"18px 28px"}>
              <Box width={"60%"}>
                <Title>
                  {title} {type}
                </Title>
                <Flex flexDirection={"row"}>
                  <Text
                    fontSize={0}
                    fontWeight={700}
                    mt={"2px"}
                    mr={2}
                    color={this._getFilterColor()}
                  >
                    FILTER
                  </Text>
                  <StudentFilterDropdown
                    updateFilters={this.handleUpdateStudentFilters}
                    clearFilter={this.handleClearStudentFilter}
                    filters={studentFilters}
                    titleColor={"white"}
                    title={filterTitle}
                  />
                </Flex>
              </Box>
              <Flex
                width={"40%"}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <BasicSearch
                  handleInput={this.handleSearchInput}
                  placeholder={"Search Student"}
                  search={searchTerm}
                />
              </Flex>
            </Flex>
          </TableHeader>

          <Table style={{ marginTop: "20px" }}>
            <Head paddingTop={"5px"}>
              <tr>
                <th style={{ textAlign: "left" }}>
                  <TableHeaderDropdown
                    filterTitle={"Students"}
                    options={STUDENT_OPTIONS}
                    filterType={"students"}
                    handleSelect={this.handleSelectFilter}
                    selected={filters.students}
                    titleWidth={"80px"}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <TableHeaderDropdown
                    filterTitle={"Actors"}
                    options={ACTOR_OPTIONS}
                    filterType={"actors"}
                    handleSelect={this.handleSelectFilter}
                    selected={filters.actors}
                    titleWidth={"80px"}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <TableHeaderDropdown
                    filterTitle={"Leave Types"}
                    options={options.leaveTypes.sort(this.compareTypes)}
                    filterType={"type"}
                    handleSelect={this.handleSelectFilter}
                    selected={filters.type}
                    titleWidth={"104px"}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <DatepickerDropdown
                    filterTitle={"Leave At"}
                    filterType={"leaveAt"}
                    handleSelect={this.handleSelectDateFilter}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <DatepickerDropdown
                    filterTitle={"Return At"}
                    filterType={"returnAt"}
                    handleSelect={this.handleSelectDateFilter}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <TableHeaderDropdown
                    filterTitle={"Leave By"}
                    options={options.transportTypes}
                    filterType={"leaveBy"}
                    handleSelect={this.handleSelectFilter}
                    selected={filters.leaveBy}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <TableHeaderDropdown
                    filterTitle={"Return By"}
                    options={options.transportTypes}
                    filterType={"returnBy"}
                    handleSelect={this.handleSelectFilter}
                    selected={filters.returnBy}
                    textAlign={"left"}
                  />
                </th>
                <th style={{ textAlign: "left" }}>
                  <Text mt={"-8px"} textAlign={"left"} pr={3}>
                    Host
                  </Text>
                </th>
                <th style={{ textAlign: "left" }}>
                  <Text mt={"-8px"} textAlign={"left"}>
                    Destination
                  </Text>
                </th>
                <th style={{ textAlign: "left" }}>
                  <Text mt={"-8px"} textAlign={"left"}>
                    Notes
                  </Text>
                </th>
                <th />
                <th />
              </tr>
            </Head>

            {this.returnLeaveList(items)}
          </Table>
        </Column>
      </InfiniteScroll>
    );
  }
}

LeavesTable.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  leaves: PropTypes.array,
  filters: PropTypes.object,
  handleUpdateFilter: PropTypes.func,
  handleClearFilter: PropTypes.func
};

LeavesTable.defaultProps = {
  title: "Leaves",
  type: "",
  leaves: [],
  handleUpdateFilter: filters => console.log("update filters", filters),
  handleClearFilter: () => console.log("clear filters")
};

function mapStateToProps(state) {
  return {
    schoolInfo: schoolSelectors.refreshSchool(state.school),
    loadingSchool: schoolSelectors.isLoading(state.school)
  };
}

const mapDispatchToProps = dispatch => ({});

export default withFirebase(
  connect(mapStateToProps, mapDispatchToProps)(LeavesTable)
);
